<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">메시지 내용 설정</span>
            <span class="txt">
                회원에게 발송할 안내 문구 또는 자주 사용하는 문자 내용을 미리 등록하고 설정할 수 있습니다.
            </span>
        </div>

        <div class="com-tab">
            <button class="on">자주 사용하는 문자</button>
            <button @click="onClickRouter('/madmin/message/setting/often')">알림톡 템플릿</button>
        </div>

        <div class="com-search-content">
            <p class="com-tit">자주 사용하는 문자 등록(최대 10건)</p>
            <div class="com-search-input">
                <input v-model="searchStr" placeholder="검색어 입력" type="text" />
                <button class="search-btn" @click="performSearch">검색</button>
            </div>
        </div>

        <div class="com-info-wrap">
            <div class="tit">
                <span>자동 치환 문자 안내</span>
                <div class="com-tooltip">
                    <button class="icon"></button>
                    <div class="detail">
                        <span class="tit">이용권 결제등록 완료시점에 자동발송 됩니다.</span>
                        <p class="txt">
                            <span class="red">[추가 사용 가능한 치환문자]</span>
                            <br />
                            #{담당강사} : 이용권의 지정된 담당강사
                            <br />
                            #{이용권명} : 이용권명
                            <br />
                            #{유효기간} : (예시 : 2020-01-01 ~ 2020-02-28)
                        </p>
                    </div>
                </div>
            </div>
            <div class="com-info-cont-list">
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{회원명}</span>
                    <dd>회원 이름</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{이용권명}</span>
                    <dd>이용권명</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{센터명}</span>
                    <dd>센터명({{ centerInfo.centerName }})</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{센터번호}</span>
                    <dd>센터대표전화번호 ({{ centerInfo.telNo | phoneNumberFilter }})</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{유효기간}</span>
                    <dd class="w220">이용권 유효기간(YYYY-MM-DD ~ YYYY-MM-DD)</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{종료일}</span>
                    <dd>이용권 종료일</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{담당강사}</span>
                    <dd>이용권 지정 담당강사</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{강사명}</span>
                    <dd>예약된 수업의 강사명</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{강사번호}</span>
                    <dd>예약된 수업의 연락처</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{수업일시}</span>
                    <dd>예약된 수업일시</dd>
                </dl>
            </div>
        </div>

        <div class="auto-send-msg often-use-msg">
            <div class="phone-list">
                <!-- 문자 영역 -->
                <div class="phone-item" v-for="(t, i) in filteredTemplates" :key="t.key">
                    <div class="phone-screen-wrap">
                        <div class="com-phone-sms other">
                            <div class="line">
                                <span class="tit">
                                    <span>
                                        제목
                                        <span class="require">*</span>
                                    </span>
                                </span>
                                <div class="input-cnt">
                                    <input type="text" placeholder="제목을 입력해주세요." v-model="t.title" />
                                </div>
                            </div>
                            <div class="line msg-cont-wrap">
                                <span class="tit">
                                    <span>
                                        내용
                                        <span class="require">*</span>
                                    </span>
                                </span>
                                <textarea
                                    placeholder="내용을 입력해주세요."
                                    @input="updateByteCount(index, $event)"
                                    v-model="t.content"
                                />
                                <div class="info-line">
                                    <span class="num">{{ byteCalculator(t.content) }}</span>
                                    / 2,000 byte
                                </div>
                            </div>
                        </div>
                        <div class="bottom-area">
                            <button class="com-btn com-btn-del" @click="deleteMessage(t.messageTemplateId)">
                                삭제
                            </button>
                            <button class="com-btn light-blue" @click="saveTemplate(t, i)">저장</button>
                        </div>
                    </div>
                </div>
                <!-- 추가 영역 -->
                <div class="phone-item phone-add-item" @click="phoneAdd">
                    <i class="ico-plus-2"></i>
                    추가
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import paymentApi from '@/assets/js/paymentApi';

export default {
    name: 'messageSettingAuto',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },

        filteredTemplates() {
            // 검색어가 없으면 전체 목록 반환
            if (!this.searchStr) {
                return this.templateList;
            }
            // 검색어가 있으면, 해당 검색어를 포함하는 제목을 가진 템플릿만 필터링하여 반환
            return this.templateList.filter((template) =>
                template.title.toLowerCase().includes(this.searchStr.toLowerCase())
            );
        },
    },
    watch: {
        templateList: function () {
            if (this.templateList.length > 10) {
                alert('자주쓰는 문자는 10개를 초과할 수 없습니다.');
                this.templateList.pop();
            }
        },
    },
    data() {
        return {
            centerId: '',
            templateList: [], //메시지 템플릿 리스트
            centerInfo: '',
            searchStr: '', // 검색어를 저장할 데이터
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터 Id
        this.init();
    },
    methods: {
        //초기화
        async init() {
            const { data } = await this.getCenterInfo();
            this.centerInfo = data;
            this.onMessageTemplate();
        },
        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
        //폰 추가하기
        phoneAdd() {
            console.log('폰추가하기 버튼 클릭');
            // this.templateList.unshift(1);
            this.templateList.push({
                senderNo: '',
                senderName: '',
                templateType: 'N',
                templateName: '',
                smsType: 'S',
                title: '',
                content: '',
                sendTime: '',
                messageTemplateId: '',
                useYn: true,
            });
        },
        async onMessageTemplate() {
            try {
                const { data } = await this.getMessageTemplate();
                this.templateList = data;
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        async getMessageTemplate() {
            try {
                const response = await api.get(`/admin/api/center/${this.centerId}/message/template`, {
                    params: {
                        auto: false,
                    },
                });
                console.log('getMessageTemplate response', response.data);
                return response;
            } catch (error) {
                console.error(error);
            }
        },
        async deleteMessage(messageTemplateId) {
            try {
                if (messageTemplateId) {
                    const response = await paymentApi.put(`/admin/api/sms/${this.centerId}/deleteTemplate`, {
                        smsTemplateId: messageTemplateId,
                    });
                    console.log('deleteMessage response', response);
                    alert('삭제되었습니다.');
                    this.onMessageTemplate();
                } else {
                    this.filteredTemplates.pop();
                }
            } catch (error) {
                console.error('Delete message error:', error);
            }
        },

        //템플릿 저장하기
        async saveTemplate(item, index) {
            const validate = this.validateValues(item, index);
            if (!validate.result) {
                alert(validate.msg);
                return false;
            }
            try {
                if (item.messageTemplateId) {
                    //수정할때
                    const { data } = await this.editSaveTemplate(item, index);
                    alert('수정되었습니다.');
                    this.onMessageTemplate();
                } else {
                    const { data } = await this.getSaveTemplate(item);
                    alert('등록되었습니다.');
                    this.onMessageTemplate();
                }
                // const { data } = await this.getSaveTemplate(templateId);
                // console.log('저장값',data);
                // alert('저장되었습니다');
                //데이터가 존재하는 경우 수정
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getSaveTemplate(item, index) {
            return api.post(`/admin/api/center/${this.centerId}/message/template/`, {
                senderNo: '', //하드코딩
                senderName: '', // 하드코딩
                templateType: 'N',
                templateName: item.templateName,
                smsType: this.byteCal(item.content) > 90 ? 'L' : 'S',
                title: item.title,
                content: item.content,
                sendTime: 'string',
                useYn: true,
            });
        },
        performSearch() {
            console.log('검색어: ', this.searchStr);
        },
        //수정될때 처리
        editSaveTemplate(item, index) {
            return api.put(`/admin/api/center/${this.centerId}/message/template/${item.messageTemplateId}`, {
                senderNo: 'string',
                senderName: 'string',
                templateType: 'N',
                templateName: item.templateName,
                smsType: this.byteCal(item.content) > 90 ? 'L' : 'S',
                title: item.title,
                content: item.content,
                sendTime: 'string',
                useYn: true,
            });
        },
        //바이트 수 계산
        byteCal(byte) {
            if (byte !== undefined) {
                let pattern = /[\u0000-\u007f]|([\u0080-\u07ff]|(.))/g;
                let result = byte.replace(pattern, '$&$1$2').length;
                // if (result > 2000) {
                //     alert('내용은 2000byte를 넘을수 없습니다.');
                //     return result;
                // }
                return result;
            }
        },
        //바이트 수 계산(2)
        byteCalculator(val) {
            let str = val; //내용
            let str_len = val.length; //길이

            let rbyte = 0;
            let rlen = 0;
            let one_char = '';
            //let str ="";
            let maxByte = 2000;

            for (let i = 0; i < str_len; i++) {
                one_char = str.charAt(i); //char 단위로 구분해서 바이트 구분
                if (escape(one_char).length > 4) {
                    rbyte += 2; // 한글2바이트
                } else {
                    rbyte++; //영문등 나머지
                }
                if (rbyte <= maxByte) {
                    rlen = i + 1; //return 할 문자열 갯수
                    // console.log('rlen:',rlen);
                }
            }
            //넘어가는 글자는 자른다
            if (rbyte > maxByte) {
                //alert(maxByte + '자를 초과 입력 할 수 없습니다.');
                str = str.substr(0, rlen);
                //this.content = str;
                //this.fnChkByte();
            } else if ((maxByte = 0)) {
                alert('문자 형식을 선택 해주세요.');
            }
            // console.log('타이핑된 값',rbyte);
            return rbyte;
        },
        validateValues(t) {
            // 필수값 체크
            let result = false;
            //템플릿제목, 이름 , 내용
            let msg = '';
            //제목
            if (t.title === '' || t.title === undefined) {
                msg = '제목을 입력하세요.';
                return { result, msg };
            }
            //내용
            if (t.content === '' || t.content === undefined) {
                msg = '내용을 입력하세요.';
                return { result, msg };
            }
            //길이
            const byteSize = this.byteCalculator(t.content);
            if (byteSize > 2000) {
                msg = '내용은 2000byte를 넘을 수 없습니다.';
                return { result: false, msg };
            }
            if (msg !== '') {
                result = false;
            } else {
                result = true;
            }

            return { result, msg };
        },
        copy(event) {
            navigator.clipboard.writeText(event.target.innerText);
            return false;
        },
        getCenterInfo() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },
    },
};
</script>
<style lang="scss"></style>
